import { memo, useState } from 'react';
import { useAsync } from 'react-use';
import cn from 'classnames';
import { ITournament } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import { TournamentService } from '@zmedia/bm-soccer-ui/service/TournamentService';
import {
    Button,
    Element,
    Icon,
    Image,
    RouterLink,
    Section,
    Sidebar,
} from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './style.module.scss';

export function LSidebar({ sidebar = {} }: { sidebar?: any }) {
    let data = sidebar?.listTournament?.items || [];
    if (!sidebar.listTournament) {
        const state = useAsync(TournamentService.getList);
        const { items = [] } = state.value?.data || {};
        data = items;
    }

    const renderItem = (item: ITournament) => {
        return (
            <RouterLink
                to={`${URL_SOCCER_PAGE.SUBPATH}${item.path}`}
                className={styles['sidebar-item']}
                key={item.name}
                title={item.name}
            >
                <Image src={item.logo} alt={'Giải đấu ' + item.name} />
                {item.name}
            </RouterLink>
        );
    };

    const renderItems = () => {
        return data.slice(0, 6)?.map((item: any) => {
            return renderItem(item);
        });
    };

    return (
        <Sidebar>
            <Section>
                <Element renderAs="h2" className={styles['sidebar-title']}>
                    Giải đấu hàng đầu
                </Element>
                <Element className={styles['sidebar-items']}>
                    {renderItems()}
                </Element>
            </Section>
            <ListFullTournament contents={sidebar?.topTournament?.section} />
        </Sidebar>
    );
}

function ListFullTournament({ contents = [] }: { contents: any }) {
    let data = contents;
    if (ArrayUtils.isEmpty(contents)) {
        const state = useAsync(TournamentService.getFullList);
        const { section = [] } = state.value?.data || {};
        data = section;
    }

    const renderItem = (item: any, index: number) => {
        return <SubItem item={item} key={item.name + index} />;
    };

    const renderItems = (items: any[] = []) => {
        return items.map((item, index) => {
            return renderItem(item, index);
        });
    };

    return (
        <Section>
            <Element renderAs="h2" className={styles['sidebar-title']}>
                Tất cả giải đấu
            </Element>
            <Element className={styles['sidebar-items']}>
                {renderItems(data)}
            </Element>
        </Section>
    );
}

function SubItem({ item }: { item: any }) {
    const [show, setShow] = useState<boolean>(false);

    const renderItem = (item: ITournament) => {
        return (
            <RouterLink
                to={`${URL_SOCCER_PAGE.SUBPATH}${item.path}`}
                className={styles['sidebar-item']}
                key={item.name}
                title={item.name}
            >
                <Image src={item.logo} alt={'Giải đấu ' + item.name} />
                {item.name}
            </RouterLink>
        );
    };

    const renderItems = (items: any[] = []) => {
        return items.map((item) => {
            return renderItem(item);
        });
    };
    return (
        <>
            <Button
                className={cn(styles['sidebar-item'], {
                    [styles['is-expanded']]: show,
                })}
                key={item.name}
                onClick={() => setShow(!show)}
            >
                <Element className={styles['parent-item']}>
                    <Image src={item.logo} alt={'Giải ' + item.name} />
                    {item.name}
                    <Icon icon={show ? 'up' : 'down'} />
                </Element>
                {show && (
                    <Element className={styles['sidebar-childs']}>
                        {renderItems(item.items || [])}
                    </Element>
                )}
            </Button>
        </>
    );
}

export default memo(LSidebar);
